<template>
    <fixed-list :dataSource="dataSource" :config="config" @onDataSourceChange="onDataSourceChange" @onPageChange="initialize" :configurable="false" :queryParam="queryParam">
        <el-table slot="elList" ref="projectListTable" :data="dataSource.Result" border @selection-change="handleSelectionChange" @current-change="handleCurrentChange" @row-dblclick="handleDBClick" highlight-current-row>
            <el-table-column type="selection" width="55" v-if="!config.isDetailDisplay"></el-table-column>
            <el-table-column v-for="(col,index)  in dataSource.ColDefs.BodyFieldParams"
                             :key="index"
                             :prop="col.FieldName"
                             :label="col.DisplayName"
                             :render-header="bindFilter(queryParam,col,ignoreField)"
                             :fixed="index==0&&(!config||!config.isDetailDisplay)"
                             :min-width="(!config||!config.isDetailDisplay)?parseInt(col.Width):0"
                             v-if="col.Visible&&(!config||!config.isDetailDisplay||(config.isDetailDisplay&&index<6))">
            </el-table-column>
        </el-table>
    </fixed-list>
</template>
<script>
    export default {
        mounted() {
           this.initialize();//加载表格数据
        },
        data() {
            return {
                ignoreField: ["DisplayArea"],
                multipleSelection: [],
                queryParam: {
                    pageIndex: 1,
                    pageSize: 10,
                    params: {}
                },
                dataSource: {
                    ColDefs: {},
                    Result: [],
                    TotalCount: 0,
                },
            }
        },
        props: {
            config: {
                isDetailDisplay: false,
            },
            selectCondition: {
            }
        },
        methods: {
            handleDBClick: function (val) {
                this.$emit("onSelectedRow", val);
                this.$emit("onDBClick", true);
            },
            onChangeEditDataSource: function (data) {
                this.config.isDetailDisplay = true;
                this.$emit("onChangeEditDataSource", data);
            },
            onDataSourceChange(ds) {
                var _this = this;
                _this.dataSource = {
                    ColDefs: {
                        BodyFieldParams: []
                    },
                    Result: [],
                    TotalCount: 0
                };
                _this.$nextTick(function () {
                    _this.dataSource = ds;

                });
            },
            handleCurrentChange: function (val) {
                this.$emit("onSelectedRow", val);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.$emit("onSelectedRow", val);
            },
            initialize: function () {
                var _this = this;
                if (_this.selectCondition) {
                    _this.Utils.extend(_this.queryParam.params, _this.selectCondition);
                }
                if (_this.config.Ids) {
                    _this.queryParam.params.Id = { fieldLabel: '', fieldValue: _this.config.Ids, fieldType: 10, ListType: 2 };
                }
                this.$ajax.query("omscc_api/logisticsProject/findList", "post", _this.queryParam, (result) => {
                    _this.dataSource = result;
                });
            },

        },

    }
</script>
